<template>
  <div class="receipt-payments-timeline">
    <v-timeline
      dense
    >
      <v-timeline-item
        v-if="payments.length === 0"
        fill-dot
        class="align-center"
      >
        <template v-slot:icon>
          <v-icon color="white">mdi-currency-usd-off</v-icon>
        </template>
        <p class="text-body-2 my-auto">
          Inga betalningar har gjorts på det här kvittot
        </p>
      </v-timeline-item>
      <v-timeline-item
        v-for="timelineItem in timelineItems"
        :key="timelineItem.id"
        fill-dot
        :color="timelineItem.color"
        :class="{ 'refunded-payment': timelineItem.isRefunded }"
      >
        <template v-slot:icon>
          <v-progress-circular
            v-if="isLoadingRefundPaymentIds.includes(timelineItem.id)"
            indeterminate
            size="24"
            class=""
            color="white"
          ></v-progress-circular>
          <v-icon v-else color="white">{{ timelineItem.icon }}</v-icon>
        </template>
        <v-row class="pt-1 mx-0">
          <v-col cols="3" class="d-flex flex-column">
            <div class="my-auto payment-date">{{ timelineItem.paidAt }}</div>
          </v-col>
          <v-col>
            <div class="payment-title"><strong>{{ timelineItem.title }}</strong></div>
            <div class="text-caption payment-subtitle">
              {{ timelineItem.subtitle }}
            </div>
            <div v-if="timelineItem.isRefunded" class="text-caption payment-sub-subtitle">
              återbetald: {{ timelineItem.refundedAtFormatted }}
            </div>
          </v-col>
          <v-col cols="2" class="d-flex">
            <v-tooltip bottom v-if="!timelineItem.isRefund && timelineItem.isSurfboardPayment && !timelineItem.isRefunded">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  class="my-auto"
                  @click="startRefund(timelineItem)"
                  :loading="isLoadingRefundPaymentIds.includes(timelineItem.id)"
                >
                  <v-icon>
                    mdi-credit-card-refund-outline
                  </v-icon>
                </v-btn>
              </template>
              <span>Återbetala</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-timeline-item>
    </v-timeline>
  </div>
</template>

<script>

import { mapState } from 'vuex'
export default {
  name: 'ReceiptPaymentsTimeline',
  props: {
    payments: Array
  },
  data: () => ({}),
  computed: {
    ...mapState(
      {
        isLoadingRefundPaymentIds: state => state.posReceipt.isLoadingRefundPaymentIds
      }
    ),
    timelineItems: function () {
      const receiptPayments = [...this.payments].sort((a, b) => {
        // b före a = 1, a före b = -1
        if (a.created_at.isBefore(b.created_at)) {
          // a betald för b
          return -1
        } else {
          return 1
        }
      })
      return receiptPayments.map(payment => {
        const paidAt = payment.created_at
        const isRefunded = payment.surfboard_order?.refunded_at !== null && payment.surfboard_order?.refunded_at !== undefined
        const refundedAtFormatted = isRefunded ? window.dayjs.parseServerDateTime(payment.surfboard_order.refunded_at).toHumanReadableDate() : ''
        let subtitle = ''
        if (payment.is_customer_credit_application) {
          subtitle = 'Betalningsmetod: Tillgodo'
        } else if (payment.surfboard_order?.payment_method_name) {
          if (payment.surfboard_order.payment_method_name === 'Swish') {
            // För Swish-betalningar via Surfboard så skriver vi ut specifikt Surfboard eftersom det också finns en PaymentMethod med samma namn
            subtitle = `Betalningsmetod: ${payment.surfboard_order.payment_method_name} (Surfboard Payments)`
          } else {
            subtitle = `Betalningsmetod: ${payment.surfboard_order.payment_method_name}`
          }
        } else {
          subtitle = `Betalningsmetod: ${payment.payment_method.name}`
        }
        return {
          id: payment.id,
          paidAt: paidAt.toHumanReadableDate(),
          icon: payment.payment_method.icon_class_name,
          color: payment.payment_method.default_gui_color,
          title: `${payment.paid_amount / 100} kr SEK`,
          isRefund: payment.paid_amount < 0,
          subtitle,
          isSurfboardPayment: payment.surfboard_order !== null,
          isRefunded,
          refundedAtFormatted
        }
      })
    }
  },
  methods: {
    startRefund: function (payment) {
      const paymentId = payment.id

      this.$store.commit('SET_OPEN_CONFIRMATION_DIALOG', {
        header: 'Bekräfta återköp',
        body: 'Är du säker på att du vill annulera denna betalning? Återbetalningen kommer att ske till kundens ursprungliga betalningsmetod och syns normalt inom 3-5 bankdagar.',
        confirmationFunction: 'posReceipt/refundReceiptPayment',
        confirmationArgument: { paymentId },
        withTimer: true,
        requiresPin: true
      })
    }
  },
  watch: {}
}
</script>
